export default __webpack_public_path__ + "static/media/Image15.3f2ce3cf.png";